import { api } from '@/core/api/';

const URL = 'api/billing/contract';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
export const getDocuments = (payload) => {
  return api.get(`${URL}/billingcontractdocuments/`, {
    params: {
      ...payload,
    },
  });
};

export const addDocument = (payload) => {
  return api.post(`${URL}/billingcontractdocument/`, payload, header);
};

export const getDocumentSigned = (contractId) => {
  return api.get(`${URL}/detailingsignedcontractdocument/${contractId}`);
};

export const addBillingDocument = (payload) => {
  return api.post(`${URL}/billingdocument/`, payload, header);
};
export const getBillingDocuments = (payload) => {
  return api.get(`${URL}/billingdocuments/`, {
    params: {
      ...payload,
    },
  });
};
export const deleteBillDocument = (documentId) => {
  return api.delete(`${URL}/billingdocument/${documentId}`);
};

export const getEvaluationDocuments = (payload) => {
  return api.get(`${URL}/evaluationdocuments/`, {
    params: {
      ...payload,
    },
  });
};
